import { SALES_EMAIL } from "./defaults";

const SUBJECT = "Request for new Project";

export const requestNewProject = () => {
  window.location.href = `mailto:${SALES_EMAIL}?subject=${encodeURIComponent(
    SUBJECT,
  )}`;
};
